import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map, catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';

import { Log } from './log.model';
import { LogInterface } from './log.interface';
import { LogFactory } from './log.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable()
export class LogService {

    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    getAll(params: HttpParams): Observable<Array<Log>> {
        // params = params.append('token', localStorage.getItem('token'));
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<any>(`${environment.apiUrl}/v${environment.apiVersion}/logs`, { params, headers: this.authService.headers() })
            .pipe(map((data) => {
                // The backend error handler answers with HTTP 200 and { success: false, message }.
                if (!Array.isArray(data)) {
                    throw new Error(data && data.message ? data.message : 'Logs konnten nicht geladen werden');
                }
                return data.map(item => LogFactory.fromObject(item));
            }), catchError(this.errorHandler));
    }

    getSingle(id: string): Observable<Log> {
        return this.http
            .get<LogInterface>(`${environment.apiUrl}/v${environment.apiVersion}/logs/${id}`, { headers: this.authService.headers() })
            .pipe(map(item => LogFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(logs: Log): Observable<any> {
        if (logs.id) {
            return this.http
                // tslint:disable-next-line:max-line-length
                .put(`${environment.apiUrl}/v${environment.apiVersion}/logs/${logs.id}`, logs, { responseType: 'text', headers: this.authService.headers() })
                .pipe(
                    map(item => JSON.parse(item)),
                    catchError(this.errorHandler)
                );
        }
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/logs`, logs, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                map(item => JSON.parse(item)),
                catchError(this.errorHandler)
            );
    }

    createError(email: string, message: string): Observable<any> {
        return this.http
            .post(`${environment.apiUrl}/v${environment.apiVersion}/errors`, { message, email }, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    remove(id: string): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/logs/${id}`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    /*remove(isbn: string): Observable<any> {
        return this.http
            .delete(`${this.api}/log/${isbn}`, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }
 */

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }

    /* getAllSearch(searchTerm: string): Observable<Array<Log>> {
        return this.http
            .get<LogInterface[]>(`${this.api}/logs/search/${searchTerm}`)
            .pipe(
                retry(3),
                map(rawCategories => rawCategories
                    .map(rawLog => LogFactory.fromObject(rawLog)),
                ),
                catchError(this.errorHandler)
            );
    } */
}



// WEBPACK FOOTER //
// ./src/app/settings/logs/shared/log.service.ts